import MapOrdersMap from "@/Pages/Auth/Deliverer/Map/MapOrdersMap";
import Modal, { ModalProps } from "../Modal/Modal";

const DeliverersMapModal = ({ onExit, ...props }: ModalProps) => {
  return (
    <Modal width={{ _: "95%", sm: "60rem" }} onExit={onExit} {...props}>
      <div className="h-[75vh]">
        <MapOrdersMap />
      </div>
    </Modal>
  );
};

export default DeliverersMapModal;
